/* eslint-disable */

import dayjs from "dayjs";
import { Form } from "antd";
import { useSelector } from "react-redux";
import { RootState } from "reducers";
import { useCreateRequestMutation } from "apis/services/requests";
import TextInput from "components/inputs/TextInput";
import UserInfo from "components/cards/UserInfo";
import SelectionInput from "components/inputs/SelectionInput";
import DatePickerInput from "components/inputs/DatePickerInput";
import AssigneeSelection from "components/inputs/AssigneeSelection";
import showSuccessMsg from "utils/showSuccessMsg";
import { RequestsTypes } from "constants/Requests";
import { PunchBoundary } from "apis/types/timekeeper";
import ModalWrapper from "../../ModalWrapper";
import styles from "../styles.module.scss";

export default function MissingPunch({
  containerStyle,
  isVisible,
  setIsVisible,
  isMultipleAssign,
  isUpdate,
  created_for,
}: any) {
  const userData = useSelector((state: RootState) => state.auth.userData);
  const request_created_for = created_for || userData;

  const [form] = Form.useForm();
  const [createRequest, { isLoading }] = useCreateRequestMutation();

  const boundaryOptions = [
    { label: "Check In", value: PunchBoundary.CheckIn },
    { label: "Check Out", value: PunchBoundary.CheckOut },
  ];

  const onFinish = (values: {
    date: string;
    time: string;
    boundary: PunchBoundary;
    employee_ids?: any;
    reason?: string;
  }) => {
    const data = {
      ...values,
      method: isUpdate ? "PATCH" : "POST",
      URL_request_type: "missing_punch_requests",
      request_type: RequestsTypes.missing_punch_requests,
      created_for: values?.employee_ids?.value ?? request_created_for?.id,
      date: dayjs(values.date).format("YYYY-MM-DD"),
      attachments: [],
      delegated_to: [],
    };

    createRequest(data)
      .unwrap()
      .then(() => {
        showSuccessMsg({ msg: "Request created successfully!" });
        form.resetFields();
        setIsVisible(false);
      })
      .catch(() => {});
  };

  return (
    <ModalWrapper
      size="large"
      headerTitle="Request Missing Punch"
      isVisible={isVisible}
      setIsVisible={setIsVisible}
      onConfirm={() => form.submit()}
      isLoading={isLoading}
    >
      <div className={`${styles.container} ${containerStyle}`}>
        <div>
          <Form form={form} layout="vertical" onFinish={onFinish}>
            {!isMultipleAssign ? (
              <div className={styles.memberContent}>
                <UserInfo data={request_created_for} />
              </div>
            ) : (
              <Form.Item
                name="employee_ids"
                label="Assignees Members"
                rules={[{ required: true }]}
              >
                <AssigneeSelection isMulti={false} />
              </Form.Item>
            )}

            <Form.Item
              name="date"
              label="Punch Date"
              rules={[{ required: true }]}
            >
              <DatePickerInput />
            </Form.Item>

            <Form.Item
              name="time"
              label="Punch Time"
              rules={[{ required: true }]}
              style={{ display: "inline-block", width: "calc(50% - 8px)" }}
            >
              <DatePickerInput picker="time" />
            </Form.Item>

            <Form.Item
              name="boundary"
              label="Punch Type"
              rules={[{ required: true }]}
              style={{
                display: "inline-block",
                width: "calc(50% - 8px)",
                margin: "0 8px",
              }}
            >
              <SelectionInput options={boundaryOptions} />
            </Form.Item>

            <Form.Item name="reason">
              <TextInput
                type="textarea"
                placeholder="Reason for the missing punch"
              />
            </Form.Item>
          </Form>
        </div>
      </div>
    </ModalWrapper>
  );
}
